/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 16:25:33
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/EditDeleteIconContainer/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { FormOutlined } from '@ant-design/icons';
import { DeleteIcon } from 'src/components/Icon';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const EditDeleteIconContainer = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const [warningVisible, setWarningVisible] = React.useState(false);
  const {
    disabled,
    onClick,
    additional,
    containerClassName,
    onDelete,
    frontPart,
    warningModalTitle,
    warningModalContent,
    displayWarningModalWhenDeleting,
  } = props;
  return (
    <WarningPopReminder
      placement='topRight'
      visibilityOption={{
        controlledByParent: true,
        controlledVisible: warningVisible,
        setControlledVisible: setWarningVisible,
      }}
      title={warningModalTitle}
      content={warningModalContent}
      onCancelText={getI18n('general.cancel')}
      onCancel={() => {
        setWarningVisible(false);
      }}
      onOkText={getI18n('general.delete')}
      onOk={() => {
        setWarningVisible(false);
        onDelete();
      }}>
      <div className={`${css.container} ${containerClassName || ''}`}>
        <div className={css.contentContainer}>{frontPart}</div>
        {additional}
        {onClick && !disabled && (
          <FormOutlined rev={'rev'} className={css.icon} onClick={onClick} />
        )}
        {onDelete && !disabled ? (
          <DeleteIcon
            onDelete={() => {
              if (displayWarningModalWhenDeleting) {
                setWarningVisible(true);
              } else {
                onDelete();
              }
            }}
            iconClassName={css.deleteIcon}
          />
        ) : (
          <React.Fragment />
        )}
      </div>
    </WarningPopReminder>
  );
};
export default EditDeleteIconContainer;
